import { SERVICES_RESP } from "../../configurations";
import { forumServices } from "../../services/win-vest-services/forum.services"

export const forumActions = {
    getPostsAction,
    postArticleAction,
    getCommentsPerPostAction,
    writeCommentAction,
    getRepliesPerCommentAction,
    toggleFlagAction,
    searchSystemAction
}

function getPostsAction(params, callback) {
    return () => {
        forumServices.getPostsService(params, res => {
            callback(res);
        })
    }
}

function postArticleAction(params, callback) {
    params.type = 'node_posts'; // only one option at current (31/12/2020);
    return () => {
        forumServices.postArticleService(params, res => {
            if (res.status === SERVICES_RESP.STATUS_OK) {
                // if (params.files.length > 0) {
                //     const attachFileParams = {
                //         name: 'file_name',
                //         nid: '584',
                //         file: params.files[0].src
                //     }
                //     forumServices.attachFileToPostService(attachFileParams, r => {

                //     })
                // }
                callback(res);
            }
        })
    }
}

function getCommentsPerPostAction(params, callback) {
    return () => {
        forumServices.getCommentsPerPostService(params, res => {
            callback(res);
        })
    }
}

function writeCommentAction(params, callback) {
    return () => {
        forumServices.writeCommentService(params, res => {
            callback(res);
        })
    }
}

function getRepliesPerCommentAction(params, callback) {
    return () => {
        forumServices.getRepliesPerCommentService(params, res => {
            callback(res);
        })
    }
}

function toggleFlagAction(params, callback) {
    return () => {
        forumServices.toggleFlagService(params, res => {
            callback(res);
        })
    }
}

function searchSystemAction(params, callback) {
    return () => {
      forumServices.searchSystemService(params, res => {
        callback(res)
      })
    }
  }